module.exports = __webpack_public_path__ + "img/adaptations5.f1e1da1c.png";